import { useQuery } from "react-query";
import { getCarriers } from "../../../../actions/CarrierAgreementMgmt/Carrier";

export const useGetCarriers = () => {
  return useQuery("GetCarriersData", getCarriers, {
    refetchOnWindowFocus: false,
  });
};
